<template>
  <div class="d-flex">
    <div class="icon" :class="{ borderIcon: arrowMoving && !stopMoving }">
      <i :class="['bx', 'bx-arrow-to-bottom', { moving: arrowMoving && !stopMoving }]"></i>
    </div>
    <div class="content">
      <div @click="item.status !== 'PROCESSING' && downloadOne()">
        <span class="d-block">{{ item.fileName }}</span>
        <div v-if="canDownload === false" class="badge" :class="[item.status ? item.status : '']">
          {{ item.status | transformData(Config.statusFileImport) }}
        </div>
        <div
          v-if="canDownload && sseData > 0"
          class="my-2 d-flex justify-content-between align-items-end"
        >
          <div class="shell">
            <div class="bar" :style="{ width: sseData + '%' }">
              <div class="spanSse" v-if="sseData >= 5">{{ sseData }}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { CommonService } from '../services/common.service'
  export default {
    name: 'ComponentDownloadFile',
    data() {
      return {
        Config,
        sseData: 0,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        arrowMoving: false,
        stopMoving: false,
        canDownload: false,
      }
    },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    created() {
      if (this.item.status === 'PROCESSING') {
        this.readFile(false)
        this.moveArrow()
      }
    },
    methods: {
      async readFile() {
        try {
          const sseClient = await fetch(
            `https://cnps.vn00.vn.fastgo.cloud:9817/file/export/download-file?id=${this.item.id}`,
            {
              headers: {
                Authorization: this.dataUser.token,
              },
            }
          )
          if (!sseClient.ok) {
            throw Error(sseClient.statusText())
          }

          for (const reader = sseClient.body.getReader(); ; ) {
            const { value, done } = await reader.read()
            if (done) {
              break
            }
            const chunk = new TextDecoder().decode(value)
            const payload = chunk.replace(/^data:/, '')
            // this.showNotification()
            if (payload.includes('PATH_FILE_S3')) {
              if (this.canDownload) {
                const parts = payload.split(' ')
                const url = parts[parts.length - 1]
                this.downloadFile(url, this.item.id)
              } else {
                this.$emit('fetchData')
                this.sseData = -1
              }
              this.toggleStopMoving()
            } else {
              this.sseData = Number(payload)
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      downloadFile(url, id) {
        this.maskReadFile(id)
        window.open(url, '_blank')
        this.$emit('fetchData')
        this.canDownload = false
      },
      async downloadOne() {
        if (this.item.status !== 'PROCESSING') {
          this.canDownload = true
          await this.readFile(true)
          this.$forceUpdate()
        }
      },
      moveArrow() {
        this.arrowMoving = !this.arrowMoving
      },
      toggleStopMoving() {
        this.stopMoving = !this.stopMoving
      },
      async maskReadFile(id) {
        await CommonService.maskReadFile({ id })
      },
    },
  }
</script>
<style scoped>
  .shell {
    height: 18px;
    width: 230px;
    border: 1px solid #aaa;
    border-radius: 13px;
    padding: 3px;
  }

  .bar {
    background: linear-gradient(to right, #b993d6, #8ca6db);
    height: 10px;
    width: 15px;
    border-radius: 9px;
  }
  .spanSse {
    float: right;
    padding: 0px 5px;
    color: #fff;
    font-size: 9px;
  }
  .moving {
    animation: moveUpDown 0.5s alternate infinite;
    top: 30% !important;
  }
  .borderIcon {
    border: 1px solid;
  }
  @keyframes moveUpDown {
    0% {
      transform: translateY(0);
    }
    70% {
      transform: translateY(-7px);
    }
  }
</style>
